import { Badge, Box, Button, Card, Divider, Flex, FormControl, IconButton, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure } from '@chakra-ui/react';
import Routes from '../../../common/api_routes';
import CustomTable from 'components/custom-table';
import React, { useEffect, useState } from 'react';
import { ApiKey, Status } from '../../../common/constant';
import { FaCog } from "react-icons/fa";
import { useDispatch } from 'react-redux';
import { showCustomDialog } from '../../../application/action/app_action';
import ApiEngine from '../../../common/api-engine';
import CustomInput from 'components/custom-input';
import { stringIsNullOrEmpty } from 'common/util';
import { Controller, useForm } from 'react-hook-form';

/**
 * @author Nelson
 */
const UserList = () => {
    const _dispatch = useDispatch();
    const [apiQuery, setApiQuery] = useState(`${Routes._MEMBER}`);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { control, handleSubmit, errors, reset } = useForm();
    const { control: filterControl, handleSubmit: filterSubmit, reset: filterReset } = useForm({
        defaultValues: {
            email: '',
            phoneNumber: ''
        }
    });
    const [selectedId, setSelectedId] = useState(null);
    const [filterObj, setFilterObj] = useState({});

    const COLUMNS = [
        {
            accessor: 'email',
            Header: 'Username'
        },
        {
            accessor: 'name',
            Header: 'Name'
        },
        {
            accessor: 'phoneNumber',
            Header: 'Phone Number'
        },
        {
            Header: 'Status',
            Cell: ({ row }) => {
                return (
                    <Badge colorScheme={row.original.status === Status._ACTIVE ? 'green' : 'red'}>{row.original.statusName}</Badge>
                )
            }
        },
        {
            accessor: 'joinDate',
            Header: 'Join Date'
        },
        {
            Header: 'Action',
            Cell: ({ row }) => {
                return (
                    <Flex display={'flex'} flexDir={'row'} justify={'center'} alignItems={'center'}>
                        <Menu isLazy>
                            <MenuButton as={IconButton} icon={<FaCog />}>
                            </MenuButton>
                            <MenuList>
                                <MenuItem onClick={() => {
                                    _dispatch(showCustomDialog({
                                        content: `Are you sure you want to ${row.original.status === Status._ACTIVE ? 'deactivate' : 'activate'} current user?`,
                                        cancelTxt: 'No',
                                        onCancel: () => { },
                                        confirmTxt: 'Yes',
                                        onConfirm: async () => {
                                            const response = await ApiEngine.put(`${Routes._ACCOUNT_UPDATE_STATUS}/${row.original.id}`);

                                            _dispatch(showCustomDialog({
                                                success: response[ApiKey._API_SUCCESS_KEY],
                                                content: response[ApiKey._API_MESSAGE_KEY],
                                                onConfirm: () => {
                                                    if (response[ApiKey._API_SUCCESS_KEY]) {
                                                        setApiQuery(`${Routes._MEMBER}?v=${Date.now().toString()}`);
                                                    }
                                                }
                                            }));
                                        }
                                    }));
                                }}>
                                    {row.original.status === Status._ACTIVE ? 'Deactivate User' : 'Activate User'}
                                </MenuItem>
                                <MenuItem onClick={() => { setSelectedId(row.original.id); onOpen(); }}>{'Change Password'}</MenuItem>
                            </MenuList>
                        </Menu>
                    </Flex>
                )
            }
        }
    ]

    /**
     * @author Nelson
     */
    useEffect(() => {
        if (!isOpen) {
            reset();
            setSelectedId(null);
        }
    }, [isOpen])

    /**
     * @author Nelson
     */
    async function onSubmit(data) {
        _dispatch(showCustomDialog({
            content: `Are you sure you want to change this new password to this user?`,
            cancelTxt: 'No',
            onCancel: () => { },
            confirmTxt: 'Yes',
            onConfirm: async () => {
                const response = await ApiEngine.put(`${Routes._ACCOUNT_RESET_PASSWORD}/${selectedId}`, JSON.stringify({ newPassword: data.password }));

                _dispatch(showCustomDialog({
                    success: response[ApiKey._API_SUCCESS_KEY],
                    content: response[ApiKey._API_MESSAGE_KEY]
                }));

                onClose();
            }
        }));
    }

    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
            <Card title={'FILTER'} mb={'1rem'} padding={'1rem'}>
                <FormControl inlineSize={'md'} display={'flex'} width={'100%'} flexDir={'row'} flexWrap={'wrap'}>
                    <Controller
                        control={filterControl}
                        name="email"
                        render={({ onChange, value, name }) => (
                            <CustomInput
                                id={name}
                                style={{ marginRight: '1rem' }}
                                label={'Email'}
                                onChange={onChange}
                                value={value}
                                placeHolder={"Enter email"} />
                        )} />
                    <Controller
                        control={filterControl}
                        name="phoneNumber"
                        render={({ onChange, value, name }) => (
                            <CustomInput
                                id={name}
                                label={'Phone Number'}
                                onChange={onChange}
                                value={value}
                                placeHolder={"Enter phone number"} />
                        )} />
                </FormControl>
                <Divider color={'#e7e7e7'} mb={'1rem'} />
                <Flex direction={'row'}>
                    <Button variant='ghost' onClick={() => { setFilterObj({ v: Date.now().toString() }); filterReset(); }}>
                        Reset
                    </Button>
                    <Button type='submit' colorScheme='blue' ml={3} onClick={() => filterSubmit(setFilterObj)()}>
                        Filter
                    </Button>
                </Flex>
            </Card>
            <Card
                padding={'1rem'}
                title={'USER_MANAGEMENT'}
                justifyContent='center'
                direction='column'
                w='100%'
                mb='0px'>
                <CustomTable
                    objFilter={filterObj}
                    columnsData={COLUMNS}
                    apiUrl={apiQuery} />
            </Card>
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{'Change New Password'}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <FormControl>
                            <Controller
                                control={control}
                                name="password"
                                defaultValue={''}
                                render={({ onChange, value, name }) => (
                                    <CustomInput
                                        id={name}
                                        isPassword
                                        label={'New Password'}
                                        onChange={onChange}
                                        value={value}
                                        placeHolder={"Enter new password"}
                                        errors={errors} />
                                )}
                                rules={{ validate: (value) => !stringIsNullOrEmpty(value) || 'Please enter valid new password' }} />
                        </FormControl>
                    </ModalBody>
                    <ModalFooter>
                        <Button variant='ghost' onClick={onClose}>
                            Close
                        </Button>
                        <Button type='submit' colorScheme='blue' ml={3} onClick={() => handleSubmit(onSubmit)()}>
                            Submit
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </Box>
    )
}

export default UserList;